import { Widget } from '@moxiltd/moxijs/src/widget/widget.js';

export class ProductsWidget extends Widget {
    async validate(): Promise<boolean> {
        this.clearError();

        let valid = true;

        if (this.required && this.getValues().length === 0) {
            this.displayError('widget.is_required');
            valid = false;
        }

        return valid;
    }

    getValues() {
        const values = [];
        this.$node.querySelectorAll('input').forEach(input => {
            if (input.value > 0)
                values.push({
                    'id': input.name,
                    'amount': input.value
                })
        });

        return values;
    }

    async getValue() {
        return this.getValues();
    }
}
